module.exports = __webpack_public_path__ + "static/media/arrow_left_blue.8f9c0321.svg";